import React, { useState } from "react";

const Header = () => {
  const [activemenu, setactivemenu] = useState("");
  const [mobileordesktop, setmobileordesktop] = useState(false);

  return (
    <header
      id="header"
      className="header header--sticky"
      data-header-hover="true"
    >
      {/*Header Navigation*/}
      <nav id="navigation" className="header-nav">
        <div className="container-fluid">
          <div className="row">
            {/*Logo*/}
            <div className="site-logo">
              <a href="home.html">
                <img
                  src="img/mainlogo.png"
                  className="logo-dark"
                  alt="Mazaar"
                />
                <img
                  src="img/mainlogo.png"
                  className="logo-light"
                  alt="Mazaar"
                />
              </a>
            </div>
            {/*End Logo*/}



            {/*Navigation Menu*/}
            <div className={mobileordesktop == true ? "nav-menu show-on-mobile" : "nav-menu"}>
              <ul>
                <li className="nav-menu-item">
                  <a href="#home">Home</a>
                  {/*Dropdown*/}
                 
                  {/*End Dropdown*/}
                </li>
                <li className="nav-menu-item mega-menu">
                  <a
                    href="#about"
                    
                  >
                    About As
                  </a>
                  {/*Dropdown*/}
                  
                  {/*End Dropdown*/}
                </li>
                <li className="nav-menu-item mega-menu">
                  <a
                    href="#service"
                  >
                    Service
                  </a>
                  {/*Dropdown*/}
                  
                  {/*End Dropdown*/}
                </li>
                <li className="nav-menu-item">
                  <a
                    href="#product"
                  >
                    Our Products
                  </a>
                  
                  {/*End Dropdown*/}
                </li>
                <li className="nav-menu-item">
                  <a
                    href="#brand"
                   
                  >
                    Our Partner
                  </a>
                  {/*Dropdown*/}
                  
                  {/*End Dropdown*/}
                </li>
               
                
              </ul>
            </div>
            {/*End Navigation Menu*/}



            {/*Nav Icons*/}
            <div className="nav-icons">
              <ul>
                <li className="nav-icon-item d-lg-none">
                  <div
                    className={mobileordesktop == true ? "nav-icon-trigger menu-mobile-btn active" : "nav-icon-trigger menu-mobile-btn"}
                    onClick={()=>{setmobileordesktop(!mobileordesktop)}}
                    title="Navigation Menu"
                  >
                    <span>
                      <i className="ti-menu" />
                    </span>
                  </div>
                </li>
                
                     
                   
                  {/*End Dropdown*/}
             
              </ul>
            </div>
            {/*End Nav Icons*/}
            {/*Search Bar*/}
            <div className="searchbar-menu">
             
            </div>
            {/*End Search Bar*/}
          </div>
        </div>
      </nav>
      {/*End Header Navigation*/}
    </header>
  );
};

export default Header;